import { render } from "./HistConsultaResultados.vue?vue&type=template&id=235f092c&scoped=true"
import script from "./HistConsultaResultados.vue?vue&type=script&lang=js"
export * from "./HistConsultaResultados.vue?vue&type=script&lang=js"

import "./HistConsultaResultados.vue?vue&type=style&index=0&id=235f092c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235f092c"]])

export default __exports__